<template>
  <section class="form-section">
    <div class="form-section__label"><v-icon small>mdi-camera-outline</v-icon>Fotografii</div>
    <v-row dense>
      <v-col cols="12" sm="6" class="pb-4">
        <PhotoInput
          :value="label"
          purpose="label"
          :max="1"
          :disabled="disabled"
          label="Fotografie etichetă (opțional)"
          hint="Eticheta albă a echipamentului: seria, MAC, utilizator / parolă, codul QR."
          @input="$emit('update:label', $event)"
          @uploading="setBusy('label', $event)"
          @error="$emit('error', $event)"
        />
        <div class="item-photos__lock">
          <v-icon small>mdi-lock-outline</v-icon>
          <span>Vizibilă doar pentru DTI și persoana responsabilă</span>
        </div>
      </v-col>
      <v-col cols="12" sm="6" class="pb-4">
        <PhotoInput
          :value="place"
          purpose="place"
          :max="1"
          :disabled="disabled"
          label="Fotografie amplasare (opțional)"
          hint="Unde se află echipamentul, ca să fie găsit ușor. O vede oricine vede echipamentul."
          @input="$emit('update:place', $event)"
          @uploading="setBusy('place', $event)"
          @error="$emit('error', $event)"
        />
      </v-col>
    </v-row>
  </section>
</template>

<script>
// Label photo (sensitive: staff + responsible person, encrypted on the server) and placement photo of an item,
// one each. `label` / `place` = PhotoInput values ([{ id, width, height }]), use with .sync.
import PhotoInput from "@/components/files/PhotoInput.vue";

export default {
  name: "ItemPhotosSection",
  components: { PhotoInput },
  props: {
    label: { type: Array, default: () => [] },
    place: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { busy: { label: false, place: false } };
  },
  methods: {
    setBusy(which, value) {
      this.busy[which] = value;
      this.$emit("uploading", this.busy.label || this.busy.place);
    },
  },
};
</script>

<style scoped>
.item-photos__lock {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  padding: 6px 10px;
  border-radius: 8px;
  background: var(--amber-bg);
  color: var(--ink-2);
  font-size: 0.88rem;
  font-weight: 600;
}
.item-photos__lock .v-icon {
  color: var(--amber) !important;
}
</style>
